module.exports = __webpack_public_path__ + "img/mkt_sale_desktop.e2fe6e40.svg";